

import request from '../utils/request.js'

//首页产品简略列表
function getHomeProducts(data){
    return request({
        url : '/productInfo/getHomeProducts',
        method : 'post',
        data
    });
}
// 通过id查询产品详情
function selectProductById(data){
    return request({
        url : '/productInfo/selectProductById',
        method : 'post',
        data
    });
}
// 查询产品列表
function selectProductInfos(data){
    return request({
        url : '/productInfo/selectProductInfos',
        method : 'post',
        data
    });
}

function selectTypeList(data){
    return request({
        url : '/productType/selectTypeList',
        method : 'post',
        data
    });
}
// 产品追溯
function decodeQrcode(data){
    return request({
        url : '/product/decodeQrcode',
        method : 'post',
        data
    })
}

export default {
    getHomeProducts,
    selectProductById,
    selectProductInfos,
    selectTypeList,
    decodeQrcode
} 


